import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';
import { DateTime } from 'luxon';
import TablaProductos from '../inventario/TablaProductos';
import Servicios from './Servicios';
import { v4 as uuidv4 } from 'uuid';

import {
    Box, Divider, Typography, Grid, Button, Container, FormControl, TextField, Autocomplete,
    Paper, CircularProgress, Dialog, TableRow, TableCell, Table, TableContainer, DialogTitle,
    DialogContent, DialogActions, FormControlLabel, FormGroup, Checkbox, Select, MenuItem, InputLabel,
    TableHead, TableBody, Fab, Accordion, AccordionSummary, AccordionDetails, Chip, Switch
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useTheme } from '@mui/material/styles'

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';
import CustomStatusChip from '../../utils/components/CustomStatusChip';

import { getDate, formatMoneyDecimal, usuarios, terminosCondiciones, formatMoney } from '../../utils/functions/Utils';
import { updateProducts, updatePrice, mxnToUsd, usdToMxn, fixDecimals, updateExistencias, stockNotice, getProductConflicts } from './cotizacion.controller';

import FormatoCotizacionModal from '../formatos/FormatoCotizacionModal';
import FormatoValeClienteModal from '../formatos/FormatoValeClienteModal';

function CotizacionModal(props) {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);
    const theme = useTheme()

    const [data, setData] = useState({
        cliente: '',
        operacion: '',
        descripcion: '',
        estatus: '',
    });

    const [fechaDeCotizacion, setFechaDeCotizacion] = useState(DateTime.now());
    const [loading, setLoading] = useState(true);
    const [currentProduct, setCurrentProduct] = useState({ clave: '', descripcion: '', cantidad: 0, precioUnitario: 0, printImage: true, costoUnitario: 0, imagen: '' });
    const [tempProducts, setTempProducts] = useState([]);
    const [products, setProducts] = useState([]);
    const [cotizacion, setCotizacion] = useState({});
    const [porcentajeDescuento, setPorcentajeDescuento] = useState(0);
    const [modalEdit, setModalEdit] = useState(false);
    const [cliente, setCliente] = useState({ name: '', rfc: '', address: '', phone: '', email: '', contact: '' });
    const [operacion, setOperacion] = useState('Venta');

    const [pie, setPie] = useState([]);
    const [keyPie, setKeyPie] = useState('');
    const [valuePie, setValuePie] = useState('');
    const [currentPie, setCurrentPie] = useState({});
    const [modalEditPie, setModalEditPie] = useState(false);

    const [showSalida, setShowSalida] = useState(false);
    const [salida, setSalida] = useState({});

    const [open, setOpen] = useState(false);
    const [openService, setOpenService] = useState(false);
    const [categories, setCategories] = useState([{}]);

    const [infoServicio, setInfoServicio] = useState({
        noReporte: '', equipo: '', marca: '', modelo: '', noSerie: '', noInventario: '', fechaReporte: DateTime.now(), hospital: '', area: '', observaciones: ''
    });
    const [hospital, setHospital] = useState('');
    const [hospitales, setHospitales] = useState([]);

    const [authKey, setAuthKey] = useState('');
    const [existencias, setExistencias] = useState([]);
    const [requestDate, setRequestDate] = useState(DateTime.now());

    const [fechaDeEntrega, setFechaDeEntrega] = useState(DateTime.now());
    const [fechaDePago, setFechaDePago] = useState(DateTime.now());
    const [clientes, setClientes] = useState([
        { id: 1, nombre: 'Cliente 1' },
        { id: 2, nombre: 'Cliente 2' },
        { id: 3, nombre: 'Cliente 3' },
        { id: 4, nombre: 'Cliente 4' },
        { id: 5, nombre: 'Cliente 5' },
    ]);

    const [dolares, setDolares] = useState(false);
    const [tipoDeCambio, setTipoDeCambio] = useState(1);
    const [decimales, setDecimales] = useState(2);
    const [calcUsd, setCalcUsd] = useState(false);
    const [calcMxn, setCalcMxn] = useState(false);

    const [descuentoProducto, setDescuentoProducto] = useState({ porcentaje: 0, importeDescuento: 0, precioFinal: 0, precioInical: 0 });

    const [showConflicts, setShowConflicts] = useState(false);
    const [productConflict, setProductConflict] = useState([]);
    const [errorSolicitud, setErrorSolicitud] = useState(false);
    const [showErrorSolicitud, setShowErrorSolicitud] = useState(false);

    const [configs, setConfigs] = useState({});
    const [toggleFormato, setToggleFormato] = useState(false);

    const [factura, setFactura] = useState({ flag: false, noFactura: '' });
    const [fechaFactura, setFechaFactura] = useState(DateTime.now());

    const [distribuidor, setDistribuidor] = useState(false);

    const [seguimiento, setSeguimiento] = useState(false);

    const [precioFinal, setPrecioFinal] = useState(0);
    const [costoTotal, setCostoTotal] = useState(0);
    const [utilidad, setUtilidad] = useState(0);
    const [sinIva, setSinIva] = useState(false);

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    // cambiar segun la empresa
    const operaciones = ['Venta', 'Servicio', 'Fabricación', 'Mercado Libre', 'Otro', ''];

    const estatus = ['Pendiente', 'Confirmado', 'Pago pendiente', 'Pagado', 'En fabricación', 'Surtido', 'Enviado', 'Pendiente de entrega/recolección', 'Entregado', 'Cancelado', 'Devolución'];
    const formaDePago = ['Efectivo', 'Tarjeta', 'Transferencia', 'Cheque'];

    // get id from url
    let id = props.id;

    useEffect(() => {
        if (!['Admin', 'Vendedor', 'Ayudante', 'Vendedor2'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Cotización';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } });
    }

    useEffect(() => {
        getData();
        return () => {
            document.body.style.backgroundColor = theme.palette.background.default;
        }
    }, [])

    const getData = async () => {
        setLoading(true);
        try {
            let res = await axios.get(`/api/orders/${id}`);
            let tmp = {}
            if (res.status === 200) {
                tmp = res.data;
                setData(res.data);
                setOperacion(res.data.operacion ? res.data.operacion : 'Venta');
                res.data.fechaDeCotizacion ? setFechaDeCotizacion(DateTime.fromISO(res.data.fechaDeCotizacion)) : setFechaDeCotizacion(DateTime.now());
                res.data.fechaDeEntrega ? setFechaDeEntrega(DateTime.fromISO(res.data.fechaDeEntrega)) : setFechaDeEntrega();
                res.data.fechaDePago ? setFechaDePago(DateTime.fromISO(res.data.fechaDePago)) : setFechaDePago();
                setPorcentajeDescuento(res.data.cotizacion.porcentajeDescuento ? res.data.cotizacion.porcentajeDescuento : 0);
                setDolares(res.data.cotizacionUsd ? res.data.cotizacionUsd.flag : false);
                setTipoDeCambio(res.data.cotizacionUsd ? res.data.cotizacionUsd.tipoDeCambio : 1);
                setDecimales(res.data.cotizacionUsd ? res.data.cotizacionUsd.decimales : 2);
                setSinIva(res.data.sinIva ? res.data.sinIva : false);
                if (res.data.cotizacionUsd) {
                    if (res.data.cotizacionUsd.dolares) {
                        const tmpProducts = updateProducts(res.data.productos, res.data.cotizacionUsd.flag, res.data.cotizacionUsd.tipoDeCambio, res.data.cotizacionUsd.decimales);
                        const tmpCotizacion = updatePrice(tmpProducts, tmpCotizacion.porcentajeDescuento, res.data.decimales, true, res.data.sinIva ? res.data.sinIva : false);
                        setCotizacion(tmpCotizacion);
                    }
                } else if (res.data.cotizacion) {
                    setCotizacion(res.data.cotizacion ? res.data.cotizacion : {});
                }
                if (res.data.productos) {
                    const orderProducts = await updateProducts(res.data.productos, dolares, tipoDeCambio, decimales);
                    const existencias = await getExistencias(orderProducts)
                    const finalProducts = updateExistencias(orderProducts, existencias);
                    setProducts(finalProducts);
                } else {
                    setProducts([]);
                }
                // updateCotizacionUsd(res.data.productos ? res.data.productos : [], res.data.cotizacion.porcentajeDescuento ? res.data.cotizacion.porcentajeDescuento : 0, res.data.cotizacionUsd ? res.data.cotizacionUsd.tipoDeCambio : 1);
                document.title = `Cotizacion ${res.data.noOrden}`;
                setPie(res.data.formatoCotizacion.pie ? res.data.formatoCotizacion.pie : terminosCondiciones);

                //datos de la salida
                setSalida({
                    elaboradoPor: res.data.elaboradoPor ? res.data.elaboradoPor : auth.user.name,
                    noOrden: res.data.noOrden,
                    solicitante: auth.user.name,
                    descripcion: `Salida de material de la orden #${res.data.noOrden}`,
                    fechaDeSolicitud: DateTime.now()
                }
                );

                // para facturas
                if (res.data.factura.flag || res.data.factura.requiereFactura) {
                    setFactura(res.data.factura);
                    res.data.factura.fechaFactura ? setFechaFactura(DateTime.fromISO(res.data.factura.fechaFactura)) : setFechaFactura();
                } else {
                    setFechaFactura();
                }

                setDistribuidor(res.data.distribuidor ? res.data.distribuidor : false);

                // para seguimiento
                if (res.data.seguimiento) {
                    setSeguimiento(res.data.seguimiento.flag ? res.data.seguimiento.flag : false);
                } else {
                    setSeguimiento(false);
                }

                res = await axios.get(`/api/configs/company/${auth.user.company}`);
                if (res.status === 200) {
                    const tmpCat = res.data.categorias;
                    tmpCat.push({ nombre: 'Envío' });
                    tmpCat.push({ nombre: 'Fabricación' });
                    tmpCat.push({ nombre: 'Modificación' });
                    tmpCat.push({ nombre: 'Reparación' });
                    tmpCat.push({ nombre: 'Mantenimiento' });
                    tmpCat.push({ nombre: 'Diseño' });
                    tmpCat.push({ nombre: 'Otro' });
                    setCategories(tmpCat);
                    setConfigs(res.data);
                }
                try {
                    const tmpCliente = { name: tmp.cliente.indexOf(' ▸ ') > -1 ? tmp.cliente.split(' ▸ ')[0].trim() : tmp.cliente, contact: tmp.cliente.indexOf(' ▸ ') > -1 ? tmp.cliente.split(' ▸ ')[1].trim() : '' }
                    res = await axios.post("/api/clients/name", tmpCliente);
                    if (res.status === 200) {
                        setCliente(res.data);
                    } else {
                        setCliente({ name: tmp.cliente, rfc: '', address: '', phone: '', email: '', contact: '' });
                    }
                } catch (err) {
                    setCliente({ name: tmp.cliente, rfc: '', address: '', phone: '', email: '', contact: '' });
                }
                res = await axios.get('/api/hospitals/');
                if (res.status === 200) {
                    setHospitales(res.data);
                }
                res = await axios.get('/api/clients/');
                if (res.status === 200) {
                    setClientes(res.data);
                }

                setLoading(false);
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al cargar la cotización, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
            setLoading(false);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const prd = updateProducts(products, false, 1, 2);
        const co = updatePrice(prd, porcentajeDescuento, 2, dolares, sinIva);
        const order = data;
        order.fechaDeCotizacion = fechaDeCotizacion;
        order.fechaDeEntrega = fechaDeEntrega;
        order.fechaDePago = fechaDePago;
        order.cotizacion = co;
        order.cotizacionUsd = { flag: dolares, tipoDeCambio: tipoDeCambio, decimales: decimales };
        order.productos = products;
        order.operacion = operacion;
        order.formatoCotizacion = {
            encabezado: [],
            datos: [],
            pie: pie.length > 0 ? pie : []
        }
        order.factura = factura;
        order.factura.fechaFactura = fechaFactura;
        order.distribuidor = distribuidor;
        order.seguimiento = { ...order.seguimiento, flag: seguimiento };
        order.sinIva = sinIva;

        try {
            const res = await axios.post(`/api/orders/${data._id}`, { order: order });
            if (res.status === 200) {
                setApiRes(state => { return { ...state, show: true, message: 'Cotización actualizada', severity: 'success' } });
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al actualizar la cotización, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
        }
    }

    const getUuid = () => { return uuidv4() };

    const handleAddProduct = ({ product }) => {
        let x = {};
        x.id = product._id;
        x.nombre = product.nombre;
        x.clave = product.clave;
        if (distribuidor) {
            x.precioUnitario = product.precioDistribuidor;
        } else {
            x.precioUnitario = product.precioUnitario;
        }
        x.costoUnitario = product.costoUnitario;
        x.descripcion = product.descripcion;
        x.categoria = product.categoria ? product.categoria : 'Otro';
        x.porcentajeDescuento = product.porcentajeDescuento ? product.porcentajeDescuento : 0;
        x.almacen = product.ubicacion.almacen ? product.ubicacion.almacen : '';
        x.existencias = product.cantidad ? product.cantidad : 0;
        x.imagen = product.imagen ? product.imagen : '';
        x.printImage = true;
        x.cantidad = 1;
        x.key = getUuid();
        setTempProducts(tempProducts => [...tempProducts, x]);
    }

    const handleAddService = (product) => {
        let x = {};
        x.id = product._id;
        x.nombre = product.nombre;
        x.clave = product.clave;
        x.precioUnitario = product.precioUnitario;
        x.costoUnitario = product.costoUnitario;
        x.descripcion = product.descripcion;
        x.categoria = product.categoria;
        x.porcentajeDescuento = product.porcentajeDescuento;
        x.imagen = product.imagen ? product.imagen : '';
        x.printImage = false;
        x.cantidad = 1;
        x.key = getUuid();
        x.servicio = true;
        setTempProducts(tempProducts => [...tempProducts, x]);
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        document.title = `Cotizacion ${data.noOrden}`;
    };

    const handleOpenService = () => {
        setOpenService(true);
    };

    const handleCloseService = () => {
        setOpenService(false);
        document.title = `Cotizacion ${data.noOrden}`;
    };

    const handleAddList = () => {
        const arrTmp = [...products, ...tempProducts];
        setProducts(deleteDuplicates(arrTmp));
        setTempProducts([]);
        setOpen(false);
        setOpenService(false);
        document.title = `Cotizacion ${data.noOrden}`;
    }

    function deleteDuplicates(array) {
        const idMap = new Map();
        let resultado = [];
        let errFlag = false;

        for (const item of array) {
            if (!idMap.has(item.id)) {
                idMap.set(item.id, true);
                resultado.push(item);
            } else {
                errFlag = true;
            }
        }
        if (errFlag) {
            setApiRes(state => { return { ...state, show: true, message: 'Se eliminaron los productos duplicados', severity: 'warning' } });
        }

        if (resultado.find(x => x.clave === 'JV-S001')) {
            const tmpEnvio = resultado.find(x => x.clave === 'JV-S001');
            resultado = resultado.filter(x => x.clave !== 'JV-S001');
            resultado.push(tmpEnvio);
        }
        return resultado;
    }

    const handleTmpDelete = (d, r) => {
        if (r < 2) {
            setTempProducts([]);
        } else {
            setTempProducts(tempProducts.filter(x => x.key !== d));
        }
    }

    useEffect(() => {
        const prd = updateProducts(products, dolares, tipoDeCambio, decimales);
        const co = updatePrice(prd, porcentajeDescuento, decimales, dolares, sinIva);
        setCotizacion(co);
    }, [products, porcentajeDescuento, dolares, tipoDeCambio, decimales, sinIva])

    const handleDelete = (d, r) => {
        if (r < 2) {
            setProducts([]);
        } else {
            setProducts(products.filter(x => x.key !== d));
        }
    }

    const handleEdit = (d) => {
        const tmpProduct = products.find(x => x.key === d.key)
        setCalcMxn(tmpProduct.precioUnitario);
        setCalcUsd(mxnToUsd(tmpProduct.precioUnitario, tipoDeCambio, decimales));
        setDescuentoProducto({ ...descuentoProducto, porcentaje: tmpProduct.porcentajeDescuento })
        setCurrentProduct(tmpProduct);
        setModalEdit(true);
    }

    const handleCloseEdit = () => {
        setModalEdit(false);
        setCurrentProduct({ clave: '', descripcion: '', cantidad: 0, precioUnitario: 0, printImage: true, costoUnitario: 0, imagen: '' });
        setDescuentoProducto({ porcentaje: 0, importeDescuento: 0, precioFinal: 0, precioInical: 0 });
    }

    const handleUpdateRefaccion = (d, e) => {
        setModalEdit(false);
        d.porcentajeDescuento = descuentoProducto.porcentaje;
        d.imagen = d.imagen.replace('https://drive.google.com/file/d/', 'https://drive.google.com/uc?export=view&id=').replace('/view?usp=drive_link', '').replace('/view?usp=sharing', '');
        setProducts(products.map(r => r.key === e ? d : r));
    }

    useEffect(() => {
        const importeDescuento = fixDecimals(currentProduct.precioUnitario * (descuentoProducto.porcentaje / 100), decimales);
        const precioUnitario = fixDecimals(currentProduct.precioUnitario - importeDescuento, decimales);
        setDescuentoProducto({ ...descuentoProducto, importeDescuento: importeDescuento, precioFinal: precioUnitario, precioInical: currentProduct.precioUnitario });
    }, [descuentoProducto.porcentaje, currentProduct.precioUnitario])

    const renderSearchModal = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xxl'}
                open={open}
                className='exo2'
                scroll='paper'
                onClose={handleClose}>
                <DialogTitle >Agregar productos</DialogTitle>
                <DialogContent sx={{ padding: '0px' }}>
                    <Grid container >
                        <Grid item xs={12} lg={9} >
                            <TablaProductos height={500} cotizacion={true} onAddProduct={handleAddProduct} />
                        </Grid>
                        <Grid item xs={12} lg={3} style={{ padding: '0px 8px' }}>
                            <Divider className='my-3' textAlign="left">
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Productos selecionados' className='text-bold' />
                            </Divider>
                            <TableContainer>
                                <Table>
                                    <TableHead sx={{ borderBottom: 'solid 1px black' }}>
                                        <TableRow>
                                            <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '14px' }}>Clave</TableCell>
                                            <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '14px' }}>Refacción</TableCell>
                                            <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '14px' }}>Precio Unitario</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            tempProducts.length > 0 ? tempProducts.map((ref, i) => (
                                                <TableRow key={i} >
                                                    <TableCell size='small' align='center' sx={{ fontSize: '14px' }}>{ref.clave}</TableCell>
                                                    <TableCell size='small' align='center' sx={{ fontSize: '14px' }}>{ref.nombre}</TableCell>
                                                    <TableCell size='small' align='center' sx={{ fontSize: '14px' }}>$ {formatMoneyDecimal(ref.precioUnitario)}</TableCell>
                                                    <TableCell size='small' align='center' sx={{ fontSize: '14px' }}><Button variant='contained' color='error' onClick={() => handleTmpDelete(ref.key, tempProducts.length)}><i className='fa fa-trash-alt'></i></Button></TableCell>
                                                </TableRow>
                                            )) : <TableRow>
                                                <TableCell size='small' align='center' colSpan={3} sx={{ fontSize: '1em' }}>No ha selecionado ninguna refacción</TableCell>
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color='success' variant='contained' onClick={() => handleAddList()}>Agregar productos &nbsp; <i className="fad fa-plus-circle"></i></Button>
                    <Button color='warning' variant='contained' onClick={() => handleClose()}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    const renderSearchServices = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={openService}
                className='exo2'
                scroll='paper'
                onClose={handleCloseService}>
                <DialogTitle >Agregar servicios</DialogTitle>
                <DialogContent>
                    <Grid container >
                        <Grid item xs={12} lg={9} >
                            <Servicios onAddService={handleAddService} configs={configs} />
                        </Grid>
                        <Grid item xs={12} lg={3} style={{ padding: '0px 8px' }}>
                            <Divider className='my-3' textAlign="left">
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Servicios seleccionados' className='text-bold' />
                            </Divider>
                            <TableContainer>
                                <Table>
                                    <TableHead sx={{ borderBottom: 'solid 1px black' }}>
                                        <TableRow>
                                            <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                            <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                            <TableCell size='small' align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Precio Unitario</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            tempProducts.length > 0 ? tempProducts.map((ref, i) => (
                                                <TableRow key={i}>
                                                    <TableCell size='small' align='center' sx={{ fontSize: '1em' }}>{ref.clave}</TableCell>
                                                    <TableCell size='small' align='center' sx={{ fontSize: '1em' }}>{ref.nombre}</TableCell>
                                                    <TableCell size='small' align='center' sx={{ fontSize: '1em' }}>$ {formatMoneyDecimal(ref.precioUnitario)}</TableCell>
                                                </TableRow>
                                            )) : <TableRow>
                                                <TableCell size='small' align='center' colSpan={3} sx={{ fontSize: '1em' }}>No ha selecionado ningún servicio</TableCell>
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color='success' variant='contained' onClick={() => handleAddList()}>Agregar servicios &nbsp; <i className="fad fa-plus-circle"></i></Button>
                    <Button color='warning' variant='contained' onClick={() => handleCloseService()}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    const renderCotizacion = () => {
        const dec = dolares ? decimales : 2;
        if (products.length > 0) {
            return (
                <>
                    <TableRow hover>
                        <TableCell size='small' sx={{ fontSize: '1.05em' }} align='center'></TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em' }} align='center'></TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em' }} align='center'></TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em', minWidth: '125px' }} align='right'><p className='mb-0 text-bold'>Subtotal</p></TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em', minWidth: '125px' }} align='right'>{`$ ${formatMoneyDecimal(cotizacion.subtotal, dec)}`}</TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em', minWidth: '145px' }} align='center'></TableCell>
                    </TableRow>
                    {
                        cotizacion.porcentajeDescuento > 0 ?
                            <TableRow hover>
                                <TableCell size='small' sx={{ fontSize: '1.05em' }} align='center'></TableCell>
                                <TableCell size='small' sx={{ fontSize: '1.05em' }} align='center'></TableCell>
                                <TableCell size='small' sx={{ fontSize: '1.05em' }} align='center'></TableCell>
                                <TableCell size='small' sx={{ fontSize: '1.05em', minWidth: '125px' }} align='right'><p className='mb-0 text-bold'>Descuento</p></TableCell>
                                <TableCell size='small' sx={{ fontSize: '1.05em', minWidth: '125px', color: 'succes.main' }} align='right'>{`$ ${formatMoneyDecimal(cotizacion.descuento, dec)}`}</TableCell>
                                <TableCell size='small' sx={{ fontSize: '1.05em', minWidth: '145px' }} align='center'></TableCell>
                            </TableRow> : null
                    }
                    <TableRow hover>
                        <TableCell size='small' sx={{ fontSize: '1.05em' }} align='center'></TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em' }} align='center'></TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em' }} align='center'></TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em', minWidth: '125px' }} align='right'><p className='mb-0 text-bold'>IVA</p></TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em', minWidth: '125px' }} align='right'>{`$ ${formatMoneyDecimal(cotizacion.iva, dec)}`}</TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em', minWidth: '145px' }} align='center'></TableCell>
                    </TableRow>
                    <TableRow hover>
                        <TableCell size='small' sx={{ fontSize: '1.05em' }} align='center'></TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em' }} align='center'></TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em' }} align='center'></TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em', minWidth: '125px' }} align='right'><p className='mb-0 text-bold'>TOTAL</p></TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em', minWidth: '125px', fontWeight: 700 }} align='right'>{`$ ${formatMoneyDecimal(cotizacion.total, dec)}`}</TableCell>
                        <TableCell size='small' sx={{ fontSize: '1.05em', minWidth: '145px' }} align='center'></TableCell>
                    </TableRow>
                </>
            )
        }
    }

    const renderProducts = () => {
        const prd = updateProducts(products, dolares, tipoDeCambio, decimales);
        const dec = dolares ? decimales : 2;
        return (
            <>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow hover >
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cant.</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Precio Unitario</TableCell>
                                <TableCell align='right' sx={{ fontWeight: '700', fontSize: '1em' }}>Importe</TableCell>
                                <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {prd.map((ref, i) => (
                                <TableRow hover key={ref.key} onDoubleClick={() => handleEdit(ref)}>
                                    <TableCell size='small' sx={{ fontSize: '1em', fontWeight: '500' }} align='center'>{ref.clave}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em', fontWeight: '500' }} align='center'>{ref.cantidad}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em', fontWeight: '500' }} align='center'>
                                        <div>
                                            <Typography sx={{ fontWeight: '500', pb: '4px' }}>{ref.descripcion}</Typography>
                                            {
                                                !data.solicitudSalida ?
                                                    <Typography className='mb-0' sx={{ color: `${stockNotice(ref).color}`, fontSize: '0.9em' }}>{stockNotice(ref).message}</Typography>
                                                    : null
                                            }
                                        </div>
                                    </TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em', minWidth: '135px', fontWeight: '500' }} align='right'>{`$ ${formatMoneyDecimal(ref.precioUnitarioConDescuento, dec)}`}</TableCell>
                                    <TableCell size='small' sx={{ fontSize: '1em', minWidth: '135px', fontWeight: '500' }} align='right'>{`$ ${formatMoneyDecimal(ref.precioUnitarioConDescuento * ref.cantidad, dec)}`}</TableCell>
                                    <TableCell size='small' align='center'>
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                            <Button sx={{ minWidth: '110px' }} variant='contained' color='primary' className='m-1' onClick={() => handleEdit(ref)}>Editar &nbsp;&nbsp;<i className='fad fa-edit'></i></Button>
                                            <Button sx={{ minWidth: '50px' }} variant='contained' color='error' className='m-1' onClick={() => handleDelete(ref.key, products.length)}>&nbsp;<i className='fa fa-trash-alt'></i>&nbsp;</Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {renderCotizacion()}
                        </TableBody>
                    </Table>
                </TableContainer>
            </>
        )
    }

    const renderEditModal = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={modalEdit}
                className='exo2'
                scroll='paper'
                onClose={handleCloseEdit}>
                <DialogTitle >Editar producto</DialogTitle>
                <DialogContent>
                    {currentProduct ?
                        <div>
                            <Grid container spacing={1}>
                                <Grid item sm={12} md={2}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField disabled label="Clave" variant="outlined" value={currentProduct.clave} onChange={(e) => setCurrentProduct({ ...currentProduct, clave: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Descripción" variant="outlined" value={currentProduct.descripcion} onChange={(e) => setCurrentProduct({ ...currentProduct, descripcion: e.target.value })} onKeyUp={(e) => { if (e.key === 'Enter') { handleUpdateRefaccion(currentProduct, currentProduct.key) } }} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={1}>
                                    <FormGroup>
                                        <FormControlLabel labelPlacement="top" label='Imagen' control={<Checkbox checked={currentProduct.printImage} onChange={() => setCurrentProduct({ ...currentProduct, printImage: !currentProduct.printImage })} />} />
                                    </FormGroup>
                                </Grid>
                                <Grid item sm={12} md={1}>
                                    <FormControl sx={{ m: 1 }} style={{ display: 'flex' }}>
                                        <TextField label="Cantidad" variant="outlined" value={currentProduct.cantidad} onChange={(e) => setCurrentProduct({ ...currentProduct, cantidad: Number(e.target.value) })} onKeyUp={(e) => { if (e.key === 'Enter') { handleUpdateRefaccion(currentProduct, currentProduct.key) } }} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField
                                            error={isNaN(Number(currentProduct.precioUnitario)) ? true : false}
                                            helperText={isNaN(Number(currentProduct.precioUnitario)) ? 'El precio debe ser un número' : `$ ${formatMoneyDecimal(currentProduct.precioUnitario)}`}
                                            label="Precio unitario MXN"
                                            variant="outlined"
                                            value={currentProduct.precioUnitario}
                                            onChange={(e) => setCurrentProduct({ ...currentProduct, precioUnitario: e.target.value })}
                                            onKeyUp={(e) => { if (e.key === 'Enter') { handleUpdateRefaccion(currentProduct, currentProduct.key) } }}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid item sm={12} md={10}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Imagen" variant="outlined" value={currentProduct.imagen} onChange={(e) => setCurrentProduct({ ...currentProduct, imagen: e.target.value })} onKeyUp={(e) => { if (e.key === 'Enter') { handleUpdateRefaccion(currentProduct, currentProduct.key) } }} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField required disabled={auth.user.rol !== 'Admin'} error={isNaN(Number(currentProduct.costoUnitario)) ? true : false} helperText={isNaN(Number(currentProduct.costoUnitario)) ? 'El costo debe ser un número' : `$ ${formatMoneyDecimal(currentProduct.costoUnitario)}`} label="Costo unitario MXN" variant="outlined" value={currentProduct.costoUnitario} onChange={(e) => setCurrentProduct({ ...currentProduct, costoUnitario: e.target.value })} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} style={{ display: 'flex', justifyContent: 'end' }}>
                                {currentProduct.servicio ?
                                    <>
                                        {
                                            currentProduct.clave.substring('S007') ?
                                                <Grid item sm={12} md={3}>
                                                    <FormControl sx={{ m: 1, minWidth: 100 }} fullWidth>
                                                        <InputLabel id="select">Categoría</InputLabel>
                                                        <Select
                                                            required
                                                            labelId="select"
                                                            value={currentProduct.categoria}
                                                            label="Categoría"
                                                            error={currentProduct.categoria.length === 0 ? true : false}
                                                            onChange={(e) => setCurrentProduct({ ...currentProduct, categoria: e.target.value })}
                                                        >
                                                            {categories.map((x, i) => (
                                                                <MenuItem key={i} value={x.nombre}>{x.nombre}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid> : <></>
                                        }
                                    </> : <></>
                                }
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid item sm={12} sx={{ margin: '8px 0px' }}>
                                    <Typography variant='body2' sx={{ color: 'comp.gray', textAlign: 'center' }}>Calculadora de utilidad/precio</Typography>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField size='small' label='Costo del producto' value={costoTotal} onChange={(e) => setCostoTotal(e.target.value)} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField size='small' label='% de utilidad deseado' value={utilidad} onChange={(e) => setUtilidad(e.target.value)} error={isNaN(Number(utilidad)) ? true : false} helperText={isNaN(Number(utilidad)) ? 'La utilidad debe ser un número entre 0 y 1' : `${utilidad * 100} %`} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField size='small' label='Precio al cliente' value={`$ ${formatMoney((costoTotal) / (1 - utilidad))}`} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid item sm={12} sx={{ margin: '8px 0px' }}>
                                    <Typography variant='body2' sx={{ color: 'comp.gray', textAlign: 'center' }}>Descuento del producto</Typography>
                                </Grid>
                                <Grid item sm={12} md={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField
                                            size='small'
                                            disabled
                                            label="Precio Inicial"
                                            variant="outlined"
                                            value={`$ ${descuentoProducto.precioInical}`}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField
                                            size='small'
                                            error={isNaN(Number(descuentoProducto.porcentaje)) ? true : false}
                                            helperText={isNaN(Number(descuentoProducto.porcentaje)) ? 'El porcentaje de descuento debe ser un número' : `${descuentoProducto.porcentaje} % → $ ${formatMoneyDecimal(descuentoProducto.importeDescuento)}`}
                                            label="% descuento"
                                            variant="outlined"
                                            type='number'
                                            value={descuentoProducto.porcentaje}
                                            onChange={(e) => setDescuentoProducto({ ...descuentoProducto, porcentaje: Number(e.target.value) })}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField
                                            size='small'
                                            disabled
                                            label="Importe descuento"
                                            variant="outlined"
                                            value={`$ ${descuentoProducto.importeDescuento}`}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={3}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField
                                            size='small'
                                            disabled
                                            label="Precio unitario con descuento"
                                            variant="outlined"
                                            value={`$ ${descuentoProducto.precioFinal}`}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div> : <div></div>}
                    {
                        dolares ?
                            <Grid container spacing={1}>
                                <Grid item sm={12} sx={{ margin: '8px 0px' }}>
                                    <Typography variant='body2' sx={{ color: 'comp.gray', textAlign: 'center' }}>Calculadora USD - MXN</Typography>
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField
                                            error={isNaN(Number(calcUsd)) ? true : false}
                                            helperText={isNaN(Number(calcUsd)) ? 'El costo debe ser un número' : `$ ${usdToMxn(calcUsd, tipoDeCambio, decimales)} MXN`}
                                            label="Precio en Dólares USD"
                                            variant="outlined"
                                            value={calcUsd}
                                            onChange={(e) => setCalcUsd(e.target.value)} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={2}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField
                                            error={isNaN(Number(calcMxn)) ? true : false}
                                            helperText={isNaN(Number(calcMxn)) ? 'El costo debe ser un número' : `$ ${mxnToUsd(calcMxn, tipoDeCambio, decimales)} USD`}
                                            label="Precio en Pesos MXN"
                                            variant="outlined"
                                            value={calcMxn}
                                            onChange={(e) => setCalcMxn(e.target.value)} />
                                    </FormControl>
                                </Grid>
                            </Grid> : <br />
                    }

                    <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
                        {/* <Button variant='contained' color='primary' className='m-1 p-2' onClick={() => handleUpdateRefaccion(currentProduct, currentProduct.key)}>&nbsp;Actualizar &nbsp;&nbsp;<i className='fad fa-cogs' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button> */}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ mr: 3 }} color='warning' variant='contained' onClick={() => handleCloseEdit()}>Cerrar</Button>
                    <Button variant='contained' color='primary' className='m-1 p-2' onClick={() => handleUpdateRefaccion(currentProduct, currentProduct.key)}>&nbsp;Actualizar &nbsp;&nbsp;<i className='fad fa-cogs' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleAddPie = (e, x) => {
        e.preventDefault();
        x.uuid = getUuid();
        if (x.key) {
            setPie(pie => [...pie, {
                key: x.key,
                value: x.value,
                uuid: x.uuid
            }]);
        }
        else {
            setPie(pie => [...pie, {
                value: x.value,
                uuid: x.uuid
            }]);
        }
        setKeyPie('');
        setValuePie('');
    }

    const handleDeletePie = (d, r) => {
        if (r < 2) {
            setPie([]);
        } else {
            setPie(pie.filter(x => x.uuid !== d)); // filter pie array to remove the one with the key
        }
    }

    const renderEditPie = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={modalEditPie}
                className='exo2'
                scroll='paper'
                onClose={handleCloseEditPie}>
                <DialogTitle >Editar términos y condiciones</DialogTitle>
                <DialogContent>
                    {currentPie ?
                        <div>
                            <Grid container spacing={1}>
                                <Grid item sm={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="..." variant="outlined" multiline value={currentPie.key} onChange={(e) => setCurrentPie({ ...currentPie, key: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="..." variant="outlined" multiline value={currentPie.value} onChange={(e) => setCurrentPie({ ...currentPie, value: e.target.value })} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div> : <div></div>}
                    <br />
                    <Grid item xs={12} sm={12} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
                        <Button variant='contained' color='primary' className='m-1 p-2' onClick={() => handleUpdatePie(currentPie, currentPie.uuid)}>&nbsp;Actualizar &nbsp;&nbsp;<i className='fad fa-cogs' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseEditPie()}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleEditPie = (d) => {
        setCurrentPie(d);
        setModalEditPie(true);
    }

    const handleUpdatePie = (d, e) => {
        setModalEditPie(false);
        let tmp = {}
        tmp.uuid = e;
        if (d.key)
            if (d.key !== '')
                tmp.key = d.key;
        if (d.value)
            tmp.value = d.value;
        setPie(pie.map(r => r.uuid === e ? tmp : r));
    }

    const handleCloseEditPie = () => {
        setModalEditPie(false);
        setCurrentPie({ key: '', value: '' });
    }

    const handleShowSalida = (e) => {
        let tmpProducts = products.filter(x => !x.servicio);
        tmpProducts = tmpProducts.filter(x => x.almacen === 'Juvalfri'); // cambiar segun la empresa
        getExistencias(tmpProducts).then(res => {
            setRequestDate(DateTime.now());
            if (res.length > 0) {
                setExistencias(res);
            } else {
                setShowErrorSolicitud(true);
            }
        });
        handleSubmit(e);
    }

    useEffect(() => {
        if (existencias.length > 0) {
            const conflicts = getProductConflicts(products);
            if (conflicts.length > 0) {
                setProductConflict(conflicts);
            } else {
                setShowSalida(true);
            }
        }
    }, [existencias])

    useEffect(() => {
        if (productConflict.length > 0) {
            setShowConflicts(true);
        }
    }, [productConflict])

    const handleCloseSalida = () => {
        setShowSalida(false);
    }

    const createInventory = (delivery) => {
        const inventory = {
            tipoMovimiento: 'salida',
            operacion: delivery.operacion,
            motivo: delivery.motivo,
            salida: {
                noValeSalida: delivery.noSolicitud,
                solicitante: delivery.solicitante,
                noOrden: delivery.noOrden ? delivery.noOrden : delivery.infoServicio.noReporte,
                cliente: delivery.cliente,
                servicio: delivery.servicio,
                infoServicio: delivery.infoServicio,
            },
            descripcion: delivery.descripcion,
            productos: delivery.productos,
            cotizacion: delivery.cotizacion,
            // auth: auth.user.name,
            estatus: 'Por Confirmar',
        }
        return inventory;
    }

    const handleSalida = async (e) => {
        e.preventDefault();
        let tmpProducts = products.filter(x => !x.servicio);
        tmpProducts = tmpProducts.filter(x => x.almacen === 'Juvalfri'); // cambiar segun la empresa

        const delivery = {
            solicitante: salida.solicitante,
            noOrden: salida.noOrden,
            estatus: 'Pendiente de validación',
            descripcion: salida.descripcion,
            productos: tmpProducts,
            cotizacion: cotizacion,
            fechaDeSolicitud: salida.fechaDeSolicitud,
            operacion: operacion,
            cliente: data.cliente,
            motivo: 'venta'
        }

        if (operacion === 'Servicio') {
            delivery.servicio = true;
            delivery.motivo = 'servicio';
            delivery.infoServicio = {
                noReporte: infoServicio.noReporte,
                hospital: hospital
            }
            if (data.elaboradoPor) {
                delivery.elaboradoPor = data.elaboradoPor;
            } else {
                delivery.elaboradoPor = auth.user.name;
            }
        } else {
            delivery.servicio = false;
            delivery.elaboradoPor = data.elaboradoPor ? data.elaboradoPor : salida.solicitante;
        }

        let verification = false;
        try {
            // verify if there is enough inventory
            let resInv = await axios.post('/api/inventories/verify', { tipoMovimiento: 'salida', products: tmpProducts, authKey: authKey, user: auth.user });
            if (resInv.status === 200) {
                verification = true;
                setApiRes(state => { return { ...state, show: true, message: resInv.data.message, severity: 'success' } });
            }
        } catch (err) {
            verification = false;
            setApiRes(state => { return { ...state, show: true, message: err.response.data.message, severity: 'error' } });
            console.log(err);
        }

        if (!verification) {
            return;
        } else {
            try {
                const resDel = await axios.post('/api/deliveries', { delivery: delivery });
                if (resDel.status === 200) {
                    try {
                        // create inventory
                        let resInv = await axios.post('/api/inventories/', { inventory: createInventory(resDel.data), authKey: authKey, user: auth.user });
                        if (resInv.status === 200) {
                            // assign inventory to delivery
                            await axios.post(`/api/deliveries/${resDel.data._id}`, { delivery: { ...delivery, noMovimiento: resInv.data.inventory.noMovimiento } });
                            // update order info
                            const order = data;
                            order.cotizacion = cotizacion;
                            order.operacion = operacion;
                            order.productos = products;
                            order.formatoCotizacion = {
                                encabezado: [],
                                datos: [],
                                pie: pie.length > 0 ? pie : []
                            };
                            order.solicitudSalida = {
                                flag: true,
                                solicitante: salida.solicitante,
                                fechaSolicitudSalida: salida.fechaDeSolicitud,
                                noSolictudSalida: resDel.data.noSolicitud,
                                idSalida: resDel.data._id,
                            }
                            order.estatus = 'Solicitud almacén';

                            try {
                                const res = await axios.post(`/api/orders/${data._id}`, { order: order });
                                if (res.status === 200) {
                                    setData(data => {
                                        return {
                                            ...data,
                                            solicitudSalida: true,
                                            solicitante: salida.solicitante,
                                            fechaSolicitudSalida: salida.fechaDeSolicitud,
                                            noSolictudSalida: resDel.data.noSolicitud,
                                            idSalida: resDel.data._id
                                        }
                                    })
                                    setApiRes(state => { return { ...state, show: true, message: 'Cotización actualizada', severity: 'success' } });
                                }
                            } catch (err) {
                                setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al actualizar la cotización, favor de intentarlo mas tarde', severity: 'error' } });
                                console.log(err);
                            }
                            setApiRes(state => { return { ...state, show: true, message: 'Se han solicitado los productos de almacen', severity: 'success' } });
                            setShowSalida(false);
                        }
                    } catch (err) {
                        setApiRes(state => { return { ...state, show: true, message: err.response.data.message, severity: 'error' } });
                        console.log(err);
                    }
                } else {
                    setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al crear la solicitud, favor de verificar la información', severity: 'error' } });
                }
            } catch (err) {
                setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al crear la solicitud, favor de verificar la información', severity: 'error' } });
                console.log(err);
            }
        }
    }

    const renderSolicitante = () => {
        if (operacion === 'Servicio') {
            return (
                <Grid item xs={12} md={6} lg={4}>
                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                        <Autocomplete
                            disablePortal
                            freeSolo={true}
                            onInputChange={(event, newInputValue) => setSalida({ ...salida, solicitante: newInputValue })}
                            inputValue={salida.solicitante}
                            options={usuarios}
                            renderInput={(params) => <TextField {...params} label='Solicita' required />}
                        />
                    </FormControl>
                </Grid>
            )
        } else {
            return (
                <Grid item sm={12} xs={12} md={6} lg={4}>
                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                        <TextField disabled label="Solicitante" variant="outlined" value={salida.solicitante} />
                    </FormControl>
                </Grid>
            )
        }
    }

    useEffect(() => {
        if (operacion === 'Servicio')
            setSalida({ ...salida, descripcion: `Salida de material de la orden #${data.noOrden} - solicita ${salida.solicitante} - para el reporte #${infoServicio.noReporte} - ${hospital}` });
        else
            setSalida({ ...salida, descripcion: `Salida de material de la orden #${data.noOrden} - solicita ${salida.solicitante}` });
    }, [salida.solicitante, infoServicio, operacion, hospital])

    const getExistencias = async (prod) => {
        try {
            if (prod.length === 0) {
                setApiRes(state => { return { ...state, show: true, message: 'No se han agregado productos a la cotización', severity: 'warning' } });
                return [];
            } else {
                let array = prod.filter(x => !x.servicio);
                array = array.filter(x => x.almacen === 'Juvalfri') // cambiar segun la empresa
                if (array.length === 0) {
                    return [];
                } else {
                    array = array.map(x => x.id);
                    array = array.filter(Boolean);
                    const x = await axios.post(`/api/products/array`, { array: array });
                    if (x.status === 200) {
                        return x.data;
                    } else {
                        setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al verificar los productos, favor de intentarlo mas tarde', severity: 'error' } });
                        return [];
                    }
                }

            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al verificar los productos, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
            return [];
        }
    }

    const modalSalida = () => {
        if (existencias.length > 0) {
            let tmpProducts = products.filter(x => !x.servicio);
            return (
                <Dialog
                    fullWidth={true}
                    maxWidth={'xl'}
                    open={showSalida}
                    className='exo2'
                    scroll='paper'
                    onClose={handleCloseSalida}>
                    <DialogTitle  >Solicitar salida de productos de almacén</DialogTitle>
                    <DialogContent>
                        <form onSubmit={(e) => handleSalida(e)}>
                            <div>
                                <Grid container spacing={1}>
                                    {renderSolicitante()}
                                    <Grid item sm={12} xs={12} md={6} lg={4}>
                                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                            <TextField disabled label="Fecha de solicitud" variant="outlined" value={getDate(salida.fechaDeSolicitud)} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item sm={12}>
                                        <FormControl sx={{ m: 1 }} style={{ display: 'flex' }}>
                                            <TextField label="Descripción" variant="outlined" value={salida.descripcion} onChange={(e) => setSalida({ ...salida, descripcion: e.target.value })} />
                                        </FormControl>
                                    </Grid>
                                    {
                                        operacion === 'Servicio' ?
                                            <>
                                                <Grid item xs={12} md={6} lg={4}>
                                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                        <TextField required label="# Reporte/Servicio" variant="outlined" value={infoServicio.noReporte} onChange={(e) => setInfoServicio({ ...infoServicio, noReporte: e.target.value })} />
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} md={6} >
                                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                        <Autocomplete
                                                            disablePortal
                                                            freeSolo={auth.user.rol === 'Tecnico' ? false : true}
                                                            onInputChange={(event, newInputValue) => setHospital(newInputValue)}
                                                            inputValue={hospital}
                                                            aria-multiline='true'
                                                            options={hospitales.map((option) => option.name)}
                                                            renderInput={(params) => <TextField required {...params} label='Unidad hospitalaria' />}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </> : <></>
                                    }
                                    <Grid item xs={12} lg={6}>
                                        <Divider className='my-4' textAlign="left">
                                            <CustomChip variant='outlined' estatus='ATENDIDO' label='Productos en el almacén' className='text-bold' />
                                        </Divider>
                                        <Typography sx={{ margin: '0px 8px', color: 'comp.gray' }} variant='body1'>Consulta: {getDate(requestDate, 'DD, HH:mm:ss')} hrs</Typography>
                                        <TableContainer>
                                            <Table>
                                                <TableHead>
                                                    <TableRow hover sx={{ backgroundColor: 'comp.tableHeaderBg' }}>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cantidad Disponible</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Descripcion</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {existencias.map((ref, i) => (
                                                        <TableRow hover key={`${ref._id}Alm`} sx={{ backgroundColor: 'comp.tableBg' }}>
                                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.cantidad}</TableCell>
                                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.nombre}</TableCell>
                                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.descripcion}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                    <Grid item xs={12} lg={6}>
                                        <Divider className='my-4' textAlign="left">
                                            <CustomChip variant='outlined' estatus='ATENDIDO' label='Productos cotizados' className='text-bold' />
                                        </Divider>
                                        <Typography sx={{ margin: '0px 8px', color: 'comp.gray' }} variant='body1'>Consulta: {getDate(requestDate, 'DD, HH:mm:ss')} hrs</Typography>
                                        <TableContainer>
                                            <Table>
                                                <TableHead>
                                                    <TableRow hover sx={{ backgroundColor: 'comp.tableHeaderBg' }}>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cantidad Solicitada</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Descripcion</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tmpProducts.map((ref, i) => (
                                                        <TableRow hover key={`${ref.id}Req`} sx={{ backgroundColor: 'comp.tableBg' }}>
                                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.clave}</TableCell>
                                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.cantidad}</TableCell>
                                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.nombre}</TableCell>
                                                            <TableCell size='small' sx={{ fontSize: '1em' }} align='center'>{ref.descripcion}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </div>
                            <br />

                            <hr style={{ margin: '24px 0px' }} />

                            <Grid container spacing={1}>
                                <Grid item sm={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField helperText='Favor de revisar la información antes de confirmar la solicitud' required type='password' label="Llave de verificación" variant="outlined" value={authKey} onChange={(e) => setAuthKey(e.target.value)} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100, maxWidth: '300px' }} style={{ display: 'flex' }}>
                                        <Button variant='contained' color='primary' size='large' className='m-1 p-2' type='submit' >&nbsp;Confirmar solicitud &nbsp;&nbsp;<i className='fad fa-badge-check' style={{ transform: 'scale(1.3)' }}></i>&nbsp;</Button>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button color='warning' variant='contained' onClick={() => handleCloseSalida()}>Cerrar &nbsp;<i className='fad fa-times'></i></Button>
                    </DialogActions>
                </Dialog>
            )
        }
    }

    const handleCloseConflicts = () => {
        setShowConflicts(false);
        setProductConflict([]);
    }

    const handleContinue = () => {
        setShowConflicts(false);
        setShowSalida(true);
    }

    const renderConflicts = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={showConflicts}
                className='exo2'
                scroll='paper'
                onClose={handleCloseConflicts}>
                <DialogTitle>Antes de continuar revisa las existencias de los siguientes productos</DialogTitle>
                <DialogContent>
                    <div>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow hover >
                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Clave</TableCell>
                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Cant.</TableCell>
                                        <TableCell align='center' sx={{ fontWeight: '700', fontSize: '1em' }}>Concepto</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {productConflict.map((ref, i) => (
                                        <TableRow hover key={`${ref.id}Conflict`}>
                                            <TableCell size='small' sx={{ fontSize: '1em', fontWeight: '500' }} align='center'>{ref.clave}</TableCell>
                                            <TableCell size='small' sx={{ fontSize: '1em', fontWeight: '500' }} align='center'>{ref.cantidad}</TableCell>
                                            <TableCell size='small' sx={{ fontSize: '1em', fontWeight: '500' }} align='center'>
                                                <div>
                                                    <Typography sx={{ fontWeight: '500', pb: '4px' }}>{ref.descripcion}</Typography>
                                                    <Typography className='mb-0' sx={{ color: `${stockNotice(ref).color}`, fontSize: '0.9em' }}>{stockNotice(ref).message}</Typography>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    {/* {renderCotizacion()} */}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button color='info' variant='contained' onClick={() => handleContinue()}>Continuar &nbsp;<i className='fad fa-check-circle'></i></Button>
                    <Button color='warning' variant='contained' onClick={() => handleCloseConflicts()}>Cerrar &nbsp;<i className='fad fa-times'></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleCloseErrorSolicitud = () => {
        setShowErrorSolicitud(false);
    }

    const renderErrorSolicitud = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'xl'}
                open={showErrorSolicitud}
                className='exo2'
                scroll='paper'
                onClose={handleCloseErrorSolicitud}>
                <DialogTitle >Aviso</DialogTitle>
                <DialogContent>
                    {/* // cambiar segun la empresa */}
                    <Typography variant='body1'>
                        No es posible generar un vale de salida ya que los objetos seleccionados no
                        pertenecen al almacén de productos de cronos. Debe haber al menos un producto del
                        almacén de Juvalfri para generar el vale de salida.
                    </Typography>
                    <br />
                    <Typography variant='body2'>No se puede generar vale para piezas de un almacén externo ni servicios como envío, modificación o fabricación.</Typography>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseErrorSolicitud()}>Cerrar &nbsp;<i className='fad fa-times'></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    useEffect(() => {
        if (operacion === 'Mercado Libre')
            setData({ ...data, observaciones: 'Venta Mercado Libre' })
    }, [operacion])

    useEffect(() => {
        if (products.length > 0) {
            getPrecioDistribuidor(distribuidor, products);
        }
    }, [distribuidor])

    const getPrecioDistribuidor = async (dist, prods) => {
        try {
            let prdIds = prods.map(x => {
                if (!x.servicio) {
                    return x.id;
                }
            });
            prdIds = prdIds.filter(Boolean);
            const res = await axios.post('/api/products/array', { array: prdIds });
            if (res.status === 200) {
                if (dist) {
                    const precios = res.data;
                    const updatePrecios = prods.map(prod => {
                        const precio = precios.find(p => p._id === prod.id);
                        if (precio) {
                            return {
                                ...prod,
                                precioUnitario: precio ? precio.precioDistribuidor ?? 0 : 0
                            }
                        } else {
                            return prod;
                        }
                    });
                    setProducts(updatePrecios);
                } else {
                    const precios = res.data;
                    const updatePrecios = prods.map(prod => {
                        const precio = precios.find(p => p._id === prod.id);
                        if (precio) {
                            return {
                                ...prod,
                                precioUnitario: precio ? precio.precioUnitario ?? 0 : 0
                            }
                        } else {
                            return prod;
                        }
                    });
                    setProducts(updatePrecios);
                }
            }
        } catch {
            console.log('Error al obtener el precio del distribuidor');
        }
    }

    return (
        <>
            <Container maxWidth='xxl' style={{ marginTop: '10px' }}>

                {loading ?
                    <Box style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '128px' }}>
                        <CircularProgress size='5em' color='primary' />
                    </Box> :

                    <Paper sx={{ padding: '24px 0px' }} elevation={3}>

                        <Container maxWidth='xl'>
                            <Box className='text-center' >
                                <Typography variant='h5' style={{ fontWeight: 700 }}>Cotización</Typography>
                            </Box>

                            <Divider className='my-3' textAlign="left">
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Datos de la cotización' className='text-bold' />
                            </Divider>

                            <div style={{ maxHeight: '90px', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', marginBottom: '16px' }}>
                                <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                                    <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'># Cotización:</p>
                                    <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{data.noOrden ? data.noOrden : ''}</p>
                                </div>
                                <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                                    <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Cliente:</p>
                                    <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{data.cliente ? data.cliente : ''}</p>
                                </div>
                                <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                                    <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Operación:</p>
                                    <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{data.operacion ? data.operacion : ''}</p>
                                </div>
                                <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                                    <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Vendedor:</p>
                                    <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{data.vendedor ? data.vendedor : ''}</p>
                                </div>
                                <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                                    <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Fecha:</p>
                                    <p style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'>{data.fechaDeCotizacion ? getDate(data.fechaDeCotizacion) : ''}</p>
                                </div>
                                <div className='d-flex align-items-stretch' style={{ width: '430px' }}>
                                    <p style={{ width: '130px', fontSize: '14px' }} className='mb-1 px-1 text-bold d-flex align-items-center'>Estatus:</p>
                                    <div style={{ width: '300px', fontSize: '14px' }} className='mb-1 px-1'><CustomStatusChip label={data.estatus ? data.estatus : ''} estatus={data.estatus ? data.estatus : ''} /></div>
                                </div>
                            </div>

                            <form onSubmit={(e) => handleSubmit(e)}>
                                <Fab type='submit' color='success' style={{ position: 'absolute', top: '20px', left: '20px', zIndex: '10', opacity: '75%' }}>
                                    <i className="fad fa-save fa-2x"></i>
                                </Fab>

                                <Accordion elevation={4} sx={{ my: 2, borderRadius: '20px' }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <Typography sx={{ fontWeight: 500 }} color='primary'>Editar Información de la Cotización</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={7}>
                                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                    <Autocomplete
                                                        disablePortal
                                                        freeSolo={true}
                                                        onInputChange={(event, newInputValue) => setData({ ...data, cliente: newInputValue })}
                                                        inputValue={data.cliente}
                                                        aria-multiline='true'
                                                        options={clientes.map((option) => `${option.name} ▸ ${option.contact}`)}
                                                        renderInput={(params) => <TextField {...params} label='Cliente' />}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={6} lg={5}>
                                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                    <DatePicker
                                                        label="Fecha de Cotización"
                                                        format="dd/MM/yyyy"
                                                        value={fechaDeCotizacion}
                                                        onChange={(newValue) => setFechaDeCotizacion(newValue)}
                                                        slotProps={{ textField: { variant: 'outlined' } }}
                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} md={8}>
                                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                    <TextField label="Descripción" multiline variant="outlined" value={data.descripcion} onChange={(e) => setData({ ...data, descripcion: e.target.value })} />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                    <Autocomplete
                                                        disablePortal
                                                        freeSolo={true}
                                                        onInputChange={(event, newInputValue) => setData({ ...data, estatus: newInputValue })}
                                                        inputValue={data.estatus}
                                                        value={data.estatus}
                                                        defaultValue={data.estatus}
                                                        options={estatus}
                                                        renderInput={(params) => <TextField {...params} label='Estatus' />}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={6} lg={3}>
                                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                    <DatePicker
                                                        label="Fecha de Entrega"
                                                        format="dd/MM/yyyy"
                                                        value={fechaDeEntrega}
                                                        onChange={(newValue) => setFechaDeEntrega(newValue)}
                                                        slotProps={{ textField: { variant: 'outlined' } }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                    <Autocomplete
                                                        disablePortal
                                                        freeSolo={false}
                                                        onInputChange={(event, newInputValue) => setData({ ...data, formaDePago: newInputValue })}
                                                        inputValue={data.formaDePago}
                                                        value={data.formaDePago}
                                                        defaultValue={data.formaDePago}
                                                        options={formaDePago}
                                                        renderInput={(params) => <TextField {...params} label='Forma de Pago' />}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={6} lg={3}>
                                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                    <DatePicker
                                                        label="Fecha de Pago"
                                                        format="dd/MM/yyyy"
                                                        value={fechaDePago}
                                                        onChange={(newValue) => setFechaDePago(newValue)}
                                                        slotProps={{ textField: { variant: 'outlined' } }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <br />
                                        <Grid container spacing={3}>
                                            <Grid item sm={12} md={2}>
                                                <FormGroup>
                                                    <FormControlLabel labelPlacement="top" label='Requiere Factura' control={<Checkbox checked={factura.requiereFactura} onChange={() => setFactura({ ...factura, requiereFactura: !factura.requiereFactura })} />} />
                                                </FormGroup>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                    <TextField label="Uso de CFDI" variant="outlined" value={factura.usoCFDI} onChange={(e) => setFactura({ ...factura, usoCFDI: e.target.value })} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                    <DatePicker
                                                        label="Fecha de Facturación"
                                                        format="dd/MM/yyyy"
                                                        value={fechaFactura}
                                                        onChange={(newValue) => setFechaFactura(newValue)}
                                                        slotProps={{ textField: { variant: 'outlined' } }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                    <TextField label="# Factura" variant="outlined" value={factura.noFactura} onChange={(e) => setFactura({ ...factura, noFactura: e.target.value })} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item sm={12} md={1}>
                                                <FormGroup>
                                                    <FormControlLabel labelPlacement="top" label='Facturado' control={<Checkbox checked={factura.flag} onChange={() => setFactura({ ...factura, flag: !factura.flag })} />} />
                                                </FormGroup>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <Box style={{ display: 'flex', justifyContent: 'end', marginTop: '12px' }}>
                                                    <Button variant='contained' size='large' color='success' className='m-1' type='submit' >Guardar &nbsp;&nbsp; <i className='fad fa-save' style={{ transform: 'scale(1.3)' }}></i></Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>

                                <Grid container spacing={3} sx={{ my: 1 }}>
                                    <Grid item xs={12} md={2} sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Button variant="contained" size='medium' color="secondary" onClick={handleOpen}>Agregar productos &nbsp; <i className="fad fa-plus-circle"></i></Button>
                                    </Grid>
                                    <Grid item xs={12} md={2} sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Button variant="contained" size='medium' color="primary" onClick={handleOpenService}>Agregar Servicios &nbsp; <i className="fad fa-plus-circle"></i></Button>
                                    </Grid>
                                    {data.solicitudSalida ?
                                        <Grid item xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Button disabled variant="contained" size='medium' color="secondary" >Los productos ya fueron solicitados en almacén &nbsp; <i className="fad fa-sign-out"></i></Button>
                                        </Grid> :
                                        <Grid item xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Button disabled={products.length > 0 ? false : true} variant="contained" size='medium' color="info" onClick={(e) => handleShowSalida(e)}>Solicitar productos en almacén &nbsp; <i className="fad fa-sign-out"></i></Button>
                                        </Grid>
                                    }
                                    <Grid item sm={12} md={2}>
                                        <FormGroup>
                                            <FormControlLabel labelPlacement="top" label='Distribuidor' control={<Checkbox checked={distribuidor} onChange={() => setDistribuidor(distribuidor => !distribuidor)} />} />
                                        </FormGroup>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                            <Autocomplete
                                                disablePortal
                                                freeSolo={false}
                                                onInputChange={(event, newInputValue) => setOperacion(newInputValue)}
                                                inputValue={operacion}
                                                value={operacion}
                                                aria-multiline='true'
                                                options={operaciones}
                                                renderInput={(params) => <TextField required {...params} label='Tipo de Operación' error={operacion === '' ? true : false} helperText={operacion === '' ? 'Debe seleccionar una opción' : ''} />}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>

                                <Divider className='my-3' textAlign="center">
                                    <CustomChip variant='outlined' estatus='AUTORIZADO' label='Productos' className='text-bold' />
                                </Divider>

                                {renderProducts()}

                                <Grid container spacing={3} sx={{ my: 1 }}>
                                    <Grid item xs={12} md={2}>
                                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                            <TextField size='small' type='number' label='% de descuento' value={porcentajeDescuento} onChange={(e) => setPorcentajeDescuento(e.target.value)} error={isNaN(Number(porcentajeDescuento)) ? true : false} helperText={isNaN(Number(porcentajeDescuento)) ? 'El descuento debe ser un número entre 0 y 100' : `${porcentajeDescuento} %`} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={7}>
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            <FormControlLabel
                                                value="Cotización en USD"
                                                control={<Switch color="primary" checked={dolares} onChange={(e) => setDolares(dolares => !dolares)} />}
                                                label="Cotización en USD"
                                                labelPlacement="top"
                                            />
                                            <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                <TextField size='small' disabled={!dolares} type='number' label='Tipo de Cambio' value={tipoDeCambio} onChange={(e) => setTipoDeCambio(e.target.value)} error={isNaN(Number(tipoDeCambio)) ? true : false} helperText={isNaN(Number(tipoDeCambio)) ? 'El tipo de cambio debe ser un número' : `$ ${formatMoneyDecimal(tipoDeCambio)} MXN → $ 1.00 USD`} />
                                            </FormControl>
                                            <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                                <TextField size='small' disabled={!dolares} type='number' label='Decimales' InputProps={{ inputProps: { min: 2, max: 6, freesolo: 'false' } }} value={decimales} onChange={(e) => setDecimales(e.target.value)} error={isNaN(Number(decimales)) ? true : false} helperText={isNaN(Number(decimales)) ? 'En numero de decimales debe ser un numero' : `${decimales} decimales después del punto`} />
                                            </FormControl>
                                            <FormControlLabel
                                                value="IVA"
                                                control={<Switch color="primary" checked={sinIva} onChange={(e) => setSinIva(sinIva => !sinIva)} />}
                                                label="Sin IVA"
                                                labelPlacement="top"
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Box style={{ display: 'flex', justifyContent: 'end', marginTop: '12px' }}>
                                            <Button variant='contained' size='large' color='success' className='m-1' type='submit' >Guardar &nbsp;&nbsp; <i className='fad fa-save' style={{ transform: 'scale(1.3)' }}></i></Button>
                                        </Box>
                                    </Grid>
                                </Grid>


                            </form>

                            <Divider className='my-3' textAlign="center" >
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Observaciones' className='text-bold' />
                            </Divider>

                            <Grid container spacing={2}>
                                <Grid item sm={10}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField multiline label="Observaciones" variant="outlined" value={data.observaciones} onChange={(e) => setData({ ...data, observaciones: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item sm={2} >
                                    <FormGroup>
                                        <FormControlLabel labelPlacement="top" label='Seguimiento' control={<Checkbox checked={seguimiento} onChange={() => setSeguimiento(seguimiento => !seguimiento)} />} />
                                    </FormGroup>
                                </Grid>
                            </Grid>
                            <br />

                            <Divider className='my-3' textAlign="center" >
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Datos del Cliente' className='text-bold' />
                            </Divider>

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField multiline label="Nombre o Razón Social" variant="outlined" value={cliente.name} onChange={(e) => setCliente({ ...cliente, name: e.target.value })} />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                    <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <TextField label="Contacto" variant="outlined" value={cliente.contact} onChange={(e) => setCliente({ ...cliente, contact: e.target.value })} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <br />

                            <Divider className='my-3' textAlign="center" >
                                <CustomChip variant='outlined' estatus='AUTORIZADO' label='Términos y Condiciones' className='text-bold' />
                            </Divider>

                            <div>
                                <div>
                                    {pie.map((n, i) => (
                                        <Grid container spacing={1} key={i} className='my-1' sx={{ border: '0.5px solid #555', borderRadius: '20px', padding: '4px' }}>
                                            <Grid item xs={12} md={4}>
                                                <Typography fontWeight={700}>{pie[i].key}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <Typography >{pie[i].value}</Typography>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <FormControl style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <Button variant='outlined' color='error' onClick={() => handleDeletePie(pie[i].uuid, pie.length)}>Eliminar &nbsp;<i className='fa fa-trash-alt'></i>&nbsp;</Button>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <FormControl style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <Button variant='outlined' color='primary' onClick={() => handleEditPie(pie[i])}>Editar &nbsp;<i className='fad fa-edit'></i></Button>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </div>
                                <form onSubmit={(e) => handleAddPie(e, { key: keyPie, value: valuePie })}>
                                    <Grid container spacing={3} className='my-2'>
                                        <Grid item xs={12} md={4}>
                                            <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                                <TextField multiline={true} label="Propiedad" variant="outlined" value={keyPie} onChange={(e) => setKeyPie(e.target.value)} />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <FormControl sx={{ minWidth: 100 }} style={{ display: 'flex' }}>
                                                <TextField multiline={true} label="Valor" variant="outlined" value={valuePie} onChange={(e) => setValuePie(e.target.value)} />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <FormControl className='mt-2'>
                                                <Button variant='outlined' color='primary' type='submit'>Agregar &nbsp; <i className="fad fa-plus-circle"></i></Button>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </form>

                                <Divider className='my-3' textAlign="center" >
                                    <CustomChip variant='outlined' estatus='AUTORIZADO' label='Observaciones para vale de entrega' className='text-bold' />
                                </Divider>

                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                            <TextField multiline label="Observaciones para vale" variant="outlined" value={data.observacionVale} onChange={(e) => setData({ ...data, observacionVale: e.target.value })} />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <br />
                            </div>

                        </Container>

                        <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
                    </Paper>
                }
            </Container>

            <Container maxWidth='xl' sx={{ mt: 3 }}>
                <Button className='mx-2' variant='contained' color='primary' onClick={() => setToggleFormato(f => !f)}>{toggleFormato ? 'Cotización' : 'Vale de entrega'} &nbsp; <i className="fad fa-eye" style={{ transform: 'scale(1.3)' }}></i></Button>
            </Container>

            {toggleFormato ?
                <Container maxWidth='xl'>
                    <Divider className='my-3' textAlign="center">
                        <Chip
                            label='Vale de entrega al cliente'
                            className='text-bold'
                            style={{ borderColor: '#ec407a', color: '#000' }}
                            variant='outlined'
                        />
                        {/* <CustomChip variant='outlined' estatus='AUTORIZADO' label='Vale de entrega al cliente' className='text-bold' style={{color: '#000000 !important'}} /> */}
                    </Divider>
                    <FormatoValeClienteModal data={data} productos={products} cotizacion={cotizacion} cliente={cliente} pie={pie} contacto={cliente.contact} company={auth.user.company} />
                </Container> :
                <Container maxWidth='xl'>
                    <Divider className='my-3' textAlign="center">
                        {/* <CustomChip variant='outlined' estatus='AUTORIZADO' label='Visualizador de Cotización' className='text-bold' /> */}
                        <Chip
                            label='Visualizador de Cotización'
                            className='text-bold'
                            style={{ borderColor: '#ec407a', color: '#000' }}
                            variant='outlined'
                        />
                    </Divider>
                    <FormatoCotizacionModal data={data} productos={updateProducts(products, dolares, tipoDeCambio, decimales)} cotizacion={cotizacion} cliente={cliente} pie={pie} dolares={dolares} tipoDeCambio={tipoDeCambio} decimales={dolares ? decimales : 2} company={auth.user.company} configs={configs} />
                </Container>
            }



            {renderSearchModal()}

            {renderSearchServices()}

            {renderEditModal()}

            {renderEditPie()}

            {showSalida ? modalSalida() : <></>}

            {showConflicts ? renderConflicts() : <></>}

            {showErrorSolicitud ? renderErrorSolicitud() : <></>}

        </>
    );
}


export default CotizacionModal;